// routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../public/components/DefaultLayout/ProtectedRoutes/ProtectedRoute';
import AdminDefaultLayout from '../admin/components/DefaultLayout';
import DefaultLayout from '../public/components/DefaultLayout';
import { Login } from '../public/pages/Auth/Login';
import { MobileAuthEntry } from '../public/pages/Auth/MobileAuthEntry';
import { Register } from '../public/pages/Auth/Register';
import { ConfirmationPage } from '../public/pages/Auth/ConfirmationPage';
import { ApproveRegistrationPage } from '../public/pages/Auth/ApproveRegistration';
import { ResetPassword } from '../public/pages/Auth/ResetPassword';
import { NewPassword } from '../public/pages/Auth/NewPassword';
import { EmailConfirm } from 'public/pages/Auth/EmailConfirm';
import { Roles } from '../public/pages/Auth/Roles';
import PublicRoute from 'enums/publicRoutes';
import { adminPath } from 'enums/adminRoutes';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={adminPath.roles()} element={<Roles />} />
      <Route
        path={`${adminPath.base()}/*`}
        element={
          <ProtectedRoute requiresFarmAdmin children={<AdminDefaultLayout />} />
        }
      />

      <Route path={PublicRoute.LOGIN} element={<Login />} />
      <Route path={PublicRoute.MOBILE_AUTH_ENTRY} element={<MobileAuthEntry />} />
      <Route path={PublicRoute.EMAIL_CONFIRM} element={<EmailConfirm />} />
      <Route path={PublicRoute.REGISTER} element={<Register />} />
      <Route path={PublicRoute.CONFIRMATION} element={<ConfirmationPage />} />
      <Route path={PublicRoute.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={PublicRoute.NEW_PASSWORD} element={<NewPassword />} />
      <Route
        path={PublicRoute.APPROVE_REGISTRATION}
        element={<ApproveRegistrationPage />}
      />
      <Route path={'/*'} element={<DefaultLayout />} />
    </Routes>
  );
};
